"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Services_1 = __importDefault(require("../Services"));
const ToasterNotification_1 = __importDefault(require("../../../../global/js/Utils/ToasterNotification"));
const RegistererOnLoadCallback_js_1 = __importDefault(require("../../classes/Providers/RegistererOnLoadCallback.js"));
const Delay_1 = require("../Utils/Delay");
const Loader_1 = require("../Utils/Loader");
const lodash_1 = __importDefault(require("lodash"));
const ExceptionAxios_1 = __importDefault(require("../Utils/ExceptionAxios"));
const axios_1 = __importDefault(require("axios"));
class Auth {
    constructor() {
        this.mobile_input_query = 'form.login-form input[name=mobile]';
        this.login_form_query = 'form.login-form';
        this.otp_input = 'code';
        this.confirmation_login_form_query = 'form#js-confirmation-login-form';
        this.$document = $(document);
        this.mobile_input = this.$document.find(this.mobile_input_query);
        this.login_form = this.$document.find(this.login_form_query);
        this.confirmation_login_form = this.$document.find(this.confirmation_login_form_query);
        this.submit_button = this.login_form.find('#login-form-submit');
        this.confirmation_submit_button = this.confirmation_login_form.find('#login-confirmation-form-submit');
    }
    main() {
        this.login();
        this.confirmationLogin();
        this.loginForm();
        this.confirmationLoginForm();
        this.initConfirmationCodeCountdown();
        this.initOtpInputs();
        this.initOTPCredential();
        this.reSendOtp();
        window.initialReCaptcha = this.reCaptchaExecuteCallback.bind(this);
    }
    loginForm() {
        const $this = this;
        this.login_form.on('submit', function (e) {
            $this.setLoadingButton();
            if (!$this.inputValidation()) {
                e.preventDefault();
                ToasterNotification_1.default.warning(3, 'شماره موبایل نادرست است.', false);
                $this.unsetLoadingButton();
                return;
            }
            if (Services_1.default.isEmpty(grecaptcha.getResponse())) {
                e.preventDefault();
                grecaptcha.execute();
            }
        });
    }
    confirmationLoginForm() {
        const $this = this;
        this.confirmation_login_form.on('submit', function (e) {
            if (!$this.confirmationInputValidation(true)) {
                e.preventDefault();
            }
            else {
                $this.$document.find('#otp input').prop('disabled', true);
            }
        });
    }
    reCaptchaExecuteCallback() {
        (0, Delay_1.delay)().time(1000).handler(() => {
            this.login_form.trigger('submit');
        }).fire();
    }
    unsetLoadingButton(unsetDelay = true) {
        const $this = this;
        (0, Delay_1.delay)().time(unsetDelay ? 500 : false).handler(function () {
            $this.submit_button.removeClass('loading');
        }).fire();
    }
    setLoadingButton() {
        this.submit_button.prop('disabled', true).addClass('loading');
    }
    login() {
        const $this = this;
        if (this.mobile_input.length === 0) {
            return;
        }
        this.mobile_input.on('focusout', function (e) {
            if ($this.inputValidation()) {
                $this.submit_button.prop('disabled', false);
            }
        });
    }
    confirmationLogin() {
        const $this = this;
        let inputs;
        if ((inputs = this.confirmation_login_form.find(`input[name^=code]:last-child`)).length === 0) {
            return;
        }
        inputs.on('focusout', function (e) {
            if ($this.confirmationInputValidation()) {
                $this.confirmation_submit_button.prop('disabled', false);
                $this.confirmation_login_form.find('input[name=confirm_code]').val($this.code_string);
            }
        });
        this.confirmation_submit_button.on('click', function (e) {
            $this.confirmation_submit_button.prop('disabled', true).addClass('loading');
            $this.confirmation_login_form.submit();
        });
    }
    inputValidation() {
        let mobileValidate, msg;
        const hint_elem = this.mobile_input.closest('.input-form-box').find('.input-hint-msg');
        if (Services_1.default.isEmpty(this.mobile_input.val())) {
            msg = 'لطفا این قسمت را خالی نگذارید.';
            hint_elem.text(msg).addClass('input-hint-error');
            this.mobile_input.removeClass('is-valid').addClass('is-invalid');
        }
        else if (!(mobileValidate = Services_1.default.isPersianMobileNumber(this.mobile_input.val()))) {
            msg = 'شماره موبایل نادرست است.';
            hint_elem.text(msg).addClass('input-hint-error');
            this.mobile_input.removeClass('is-valid').addClass('is-invalid');
        }
        else {
            hint_elem.removeClass('input-hint-error');
            this.mobile_input.removeClass('is-invalid').addClass('is-valid');
        }
        return mobileValidate;
    }
    initOTPCredential() {
        const $this = this;
        if ("OTPCredential" in window) {
            RegistererOnLoadCallback_js_1.default.booted(() => {
                const inputs = $('#otp.otp-inputs > input');
                try {
                    const ac = new AbortController();
                    if (this.confirmation_login_form.length > 0) {
                        // Abort the OTP request if the user attempts to submit the form manually
                        this.confirmation_login_form.on("submit", (e) => {
                            console.dir(ac);
                            ac.abort();
                        });
                    }
                    navigator.credentials
                        .get({
                        signal: ac.signal,
                        // @ts-ignore
                        otp: { transport: ["sms"] },
                    })
                        .then((otp) => {
                        // @ts-ignore
                        const splitNumber = [...otp.code];
                        inputs.toArray().forEach((elem, index) => {
                            if (!isNaN(lodash_1.default.toNumber(splitNumber[index]))) {
                                $(elem).val(splitNumber[index]).trigger('focus');
                            }
                        });
                        inputs.trigger('focusout');
                        setTimeout(() => {
                            $this.confirmation_submit_button.trigger('click');
                        }, 250);
                    })
                        .catch((e) => {
                        if (!(e instanceof DOMException)) {
                            Services_1.default.captureError(e);
                        }
                    });
                }
                catch (e) {
                    if (!(e instanceof DOMException)) {
                        Services_1.default.captureError(e);
                    }
                }
            });
        }
    }
    confirmationInputValidation(submit = false) {
        let msg;
        let failValidation;
        const code = this.confirmation_login_form.find(`input[name^=${this.otp_input}]`).map(function (idx, elem) {
            return $(elem).val();
        }).get();
        const code_string = this.code_string = code.join('');
        if ((failValidation = Services_1.default.isEmpty(code_string))) {
            msg = 'لطفا کد ارسالی را وارد کنید';
        }
        else if ((failValidation = code_string.length !== 6)) {
            msg = 'لطفا کد تایید را بصورت کامل وارد کنید';
        }
        if (failValidation) {
            if (submit)
                ToasterNotification_1.default.error(5, msg);
            this.confirmation_submit_button.prop('disabled', true).removeClass('loading');
        }
        return !failValidation;
    }
    initConfirmationCodeCountdown() {
        const $countdownOptionEnd = $("#countdown-confirmation");
        if ($countdownOptionEnd.length) {
            $countdownOptionEnd
                .countdown($countdownOptionEnd.data('resend-time'))
                .on('finish.countdown', function () {
                $(this).parent().removeClass('text-primary').html("<button type='button' class='btn btn-danger border-radius-lg btn-sm re-send-otp'>ارسال مجدد</button>");
            })
                .on('update.countdown', function (event) {
                // @ts-ignore
                $(this).text(event.strftime('%M:%S'));
            });
        }
    }
    reSendOtp() {
        const $this_auth = this;
        this.$document.on('click', '.re-send-otp', function (e) {
            e.preventDefault();
            const $this = $(this);
            $this.prop('disabled', true).addClass('loading');
            (0, Loader_1.loader)('.form', { message: '', opacity: 0.3 }).fire();
            let statusCode;
            (0, axios_1.default)({
                url: $this.closest('form#js-confirmation-login-form').data('resend-otp'),
                method: 'POST',
            }).then((res) => {
                const response = res.data;
                if (response.status === 200) {
                    $this.parent().html(`<span class="btn btn-danger btn-xs w-60px" id="countdown-confirmation" data-resend-time="${response.data.otp_ttl}"></span>
                                        <span class="text-dark mr-2"> - مانده تا دریافت مجدد کد</span>`);
                    const messageBag = response.messageBag;
                    ToasterNotification_1.default.setOptions(messageBag.type, 3, messageBag.message);
                    $this_auth.initConfirmationCodeCountdown();
                }
            }).catch(function (error) {
                var _a;
                statusCode = error.response.status;
                (0, ExceptionAxios_1.default)((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.messageBag, () => {
                    ToasterNotification_1.default.error(3, 'خطای داخلی رخ داده است.');
                });
                (0, Delay_1.delay)().time(1500).handler(() => {
                    if (lodash_1.default.has(error.response.data, 'data.redirect') && statusCode === 403) {
                        Services_1.default.Request.redirect(lodash_1.default.get(error.response.data, 'data.redirect'));
                    }
                }).fire();
            }).finally(function () {
                (0, Delay_1.delay)().time(500).handler(() => {
                    (0, Loader_1.loader)('.form').down();
                    $this.prop('disabled', statusCode === 403).removeClass('loading');
                }).fire();
            });
        });
    }
    initOtpInputs() {
        const $this = this;
        const inputs = $('#otp.otp-inputs > input');
        inputs.inputFilter({ regex: '[0-9]' });
        inputs.on('keydown keyup paste', function (event) {
            if (event.type === 'keydown' && (event.key === "Tab" || event.keyCode === 9)) {
                event.preventDefault();
                return false;
            }
            const $this_input = $(this);
            if (event.type === 'paste') {
                const clipboardData = event.originalEvent.clipboardData.getData('Text');
                if (!isNaN(lodash_1.default.toNumber(clipboardData)) && clipboardData.length > 2) {
                    const splitNumber = [...clipboardData];
                    inputs.toArray().forEach((elem, index) => {
                        if (!isNaN(lodash_1.default.toNumber(splitNumber[index]))) {
                            $(elem).val(splitNumber[index]).trigger('focus');
                        }
                    });
                }
            }
            else if (event.type === 'keyup') {
                if (event.key === "Backspace") {
                    $this_input.val('');
                    if (!$this_input.is(':first-child'))
                        $this_input.prev().trigger('focus');
                }
                else {
                    if ($this_input.is(':last-child') && $this_input.val() !== '') {
                        $this_input.trigger('focusout');
                        $this.confirmation_submit_button.trigger('focus');
                        return true;
                    }
                    else if (!Services_1.default.isEmpty(event.target.value)) {
                        if (!$this_input.is(':last-child'))
                            $this_input.next().trigger('focus');
                    }
                }
            }
        });
    }
}
exports.default = Auth;
